import type { AddEthereumChainParameter } from "@web3-react/types"

export const LOCAL_CHAIN_ID = 31337
export const MATIC_TESTNET_CHAIN_ID = 80001
export const MATIC_MAINNET = 137

/**
 * CHAIN_ID is used to:
 *
 * frontend
 * - network provider chain
 * - metamask chain setting (when click on add network button)
 * 
 * widget
 * - use this chains contracts
 * widget sets the testnet chainid with buildTestnet
 */
export const CHAIN_ID = MATIC_MAINNET
// @ts-ignore
export const isLocalChain = () => CHAIN_ID === LOCAL_CHAIN_ID
// @ts-ignore
export const isTestnet = () => CHAIN_ID === MATIC_TESTNET_CHAIN_ID

export function getAddChainParameters(chainId: number): AddEthereumChainParameter | number {
    const chainInformation = CHAINS[chainId]
    if (isExtendedChainInformation(chainInformation)) {
        return {
            chainId,
            chainName: chainInformation.name,
            nativeCurrency: chainInformation.nativeCurrency,
            rpcUrls: chainInformation.urls,
            blockExplorerUrls: chainInformation.blockExplorerUrls,
        }
    } else {
        return chainId
    }
}
function isExtendedChainInformation(
    chainInformation: BasicChainInformation | ExtendedChainInformation
): chainInformation is ExtendedChainInformation {
    return !!(chainInformation as ExtendedChainInformation).nativeCurrency
}
const MATIC: AddEthereumChainParameter["nativeCurrency"] = {
    name: "Matic",
    symbol: "MATIC",
    decimals: 18,
}
const ETH: AddEthereumChainParameter["nativeCurrency"] = {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
}

interface BasicChainInformation {
    urls: string[]
    name: string
}

interface ExtendedChainInformation extends BasicChainInformation {
    nativeCurrency: AddEthereumChainParameter["nativeCurrency"]
    blockExplorerUrls: AddEthereumChainParameter["blockExplorerUrls"]
}

export const CHAINS: { [chainId: number]: BasicChainInformation | ExtendedChainInformation } = {
    137: {
        urls: [
            "https://polygon.drpc.org",
            "https://polygon.llamarpc.com",
            "https://rpc.ankr.com/polygon",
            "https://polygon-bor-rpc.publicnode.com",
            "https://polygon-rpc.com",
            `https://polygon-mainnet.infura.io/v3/caa2e8560d2a40b485160d871fbe8fd0`,
        ].filter((url) => url !== undefined) as string[],
        name: "Polygon Mainnet",
        nativeCurrency: MATIC,
        blockExplorerUrls: ["https://polygonscan.com"],
    },
    80001: {
        urls: [
            `https://matic-mumbai.chainstacklabs.com`,
            `https://polygon-mumbai.infura.io/v3/caa2e8560d2a40b485160d871fbe8fd0`,
        ].filter((url) => url !== undefined) as string[],
        name: "Polygon Mumbai",
        nativeCurrency: MATIC,
        blockExplorerUrls: ["https://mumbai.polygonscan.com"],
    },
    31337: {
        urls: ["http://127.0.0.1:8545"],
        name: "localhost",
        nativeCurrency: ETH,
        blockExplorerUrls: [],
    },
}

export const URLSForChain = (chainId: number): { [chainId: number]: string[] } => {
    return { [chainId]: CHAINS[chainId].urls }
}

export const URLS: { [chainId: number]: string[] } = Object.keys(CHAINS).reduce<{
    [chainId: number]: string[]
}>((accumulator, chainId) => {
    const validURLs: string[] = CHAINS[Number(chainId)].urls

    if (validURLs.length) {
        accumulator[Number(chainId)] = validURLs
    }

    return accumulator
}, {})
